import { isChargerSelectable } from '@/components/points/ChargerStatusBadge';
import type { StationDetailOut } from '@/api/stations';

export interface ConnectorTypeGroup {
  type: string;
  free: number;
  total: number;
  /** Maior potência (kW) entre os conectores desse tipo. */
  maxKw: number;
}

/** Agrupa os conectores de uma estação por tipo (CCS2/Type2/CHAdeMO/GBT),
 * cruzando todos os carregadores — usado no peek do mapa (mapfirst-a.jsx ·
 * `ConnectorAvail`) e no resumo por tipo da sheet expandida
 * (mapfirst-multi-noscroll.jsx · G · `TipoTile`). */
export function connectorsByType(station: StationDetailOut): ConnectorTypeGroup[] {
  const map = new Map<string, ConnectorTypeGroup>();
  for (const charger of station.chargers) {
    for (const conn of charger.connectors) {
      const group = map.get(conn.type) ?? { type: conn.type, free: 0, total: 0, maxKw: 0 };
      group.total += 1;
      if (isChargerSelectable(conn.state)) group.free += 1;
      const kw = Number(conn.max_power_kw);
      if (kw > group.maxKw) group.maxKw = kw;
      map.set(conn.type, group);
    }
  }
  return Array.from(map.values());
}
